import { useEffect } from "react";
import { Link } from "react-router-dom";
import { MaskLines, Reveal } from "../components/Motion";
import { Btn, Container } from "../components/Shared";
import { LogoMark } from "../components/Logo";
import { useLang } from "../lib/lang";
import { useSeo } from "../lib/seo";

export default function NotFound() {
  const { t, r, lang } = useLang();
  useSeo({ title: "404 – Translinked", description: t.nf.text, path: "/404", lang, noindex: true });
  useEffect(() => undefined, []);
  return (
    <main className="flex min-h-screen items-center pt-[72px]" data-testid="not-found-page">
      <Container className="grid items-center gap-12 py-20 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <p className="font-mono text-sm text-[var(--teal-ink)]">404</p>
          <h1 className="mt-6 font-display text-4xl font-light leading-tight text-[var(--ink)] md:text-6xl"><MaskLines lines={[t.nf.title]} /></h1>
          <Reveal delay={0.3} className="mt-6 max-w-lg text-lg text-[var(--muted)]">{t.nf.text}</Reveal>
          <Reveal delay={0.4} className="mt-10 flex flex-wrap gap-3">
            <Btn to={r("home")} data-testid="nf-home-btn">{t.nf.home}</Btn>
            <Btn to={r("upload")} variant="ghost" data-testid="nf-upload-btn">{t.nav.cta}</Btn>
          </Reveal>
          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {["translation", "certified", "interpreting", "blog", "contact"].map((k) => <Link key={k} to={r(k)} className="text-[var(--ink)] underline decoration-[var(--line)] underline-offset-4 hover:decoration-[var(--teal)]">{t.nav[k]}</Link>)}
          </div>
        </div>
        <div className="hidden lg:col-span-5 lg:block"><LogoMark className="w-full opacity-80" draw /></div>
      </Container>
    </main>
  );
}
